import createPersistedReducer from '@/redux/lib/createPersistedReducer';

const initialState = {
  jwt: {},
  settings: {},
  companies: null,
  companiesOptions: [],
  selectedCompany: null,
  sessionCompanyId: null,
  sessionCompanyChannel: null,
  commandBar: [],
  recentActions: [],
  toolbarPosition: { x: 0, y: 0 },
  editorToolbarPosition: { x: 0, y: 0 }
};

const persistConfig = {
  key: 'userReducer',
  whitelist: ['companyId', 'companies', 'companiesOptions', 'selectedCompany', 'recentActions', 'toolbarPosition'],
  transforms: []
};

export default createPersistedReducer(
  initialState,
  {
    LOGOUT: (state) => {
      return {
        ...state,
        jwt: {},
        settings: {}
      };
    },

    SET_USER_PROFILE: (state, payload) => ({
      ...state,
      settings: payload?.settings,
      jwt: payload?.jwt
    }),

    GET_USER_COMPANIES_SUCCESS: (state, payload) => ({
      ...state,
      companyId: state.companyId || (payload.data?.companies[0] || {}).id,
      companies: payload.data.companies
    }),

    GET_USER_COMPANIES_OPTIONS_SUCCESS: (state, payload) => ({
      ...state,
      companiesOptions: payload?.data?.companies || [],
      selectedCompany: payload?.data?.selectedCompany || null
    }),

    GET_USER_SETTINGS_SUCCESS: (state, payload) => ({
      ...state,
      settings: payload.data?.[0]
    }),

    PUT_COMPANY: (state, payload) => ({
      ...state,
      companies: state.companies.map((n) => (n.id === payload.id ? payload : n))
    }),

    SEARCH_COMMAND_BAR_SUCCESS: (state, payload) => ({
      ...state,
      commandBar: payload.data
    }),

    CLEAR_COMMAND_BAR: (state) => ({
      ...state,
      commandBar: []
    }),

    ADD_RECENT_ACTION: (state, payload) => {
      const maxRecentActions = 10;
      const { item } = payload;
      const timestamp = Date.now();

      // Add timestamp to new action
      const actionWithTimestamp = {
        ...item,
        uniqueKey: `${item.primaryKey}-${timestamp}`,
        timestamp
      };

      // Add new action and sort by timestamp descending
      const recentActions = [...state.recentActions.filter((action) => action.primaryKey !== item.primaryKey), actionWithTimestamp] //
        .sort((a, b) => b.timestamp - a.timestamp)
        .slice(0, maxRecentActions);

      return {
        ...state,
        recentActions
      };
    },

    SET_TOOLBAR_POSITION: (state, payload) => ({
      ...state,
      toolbarPosition: payload
    }),

    SET_SESSION_COMPANY_ID: (state, payload) => ({
      ...state,
      sessionCompanyId: payload
    }),

    SET_SESSION_COMPANY_CHANNEL: (state, payload) => ({
      ...state,
      sessionCompanyChannel: payload
    })
  },
  persistConfig
);
